import { render, staticRenderFns } from "./CancelationModal.vue?vue&type=template&id=60d49cd3"
import script from "./CancelationModal.vue?vue&type=script&lang=js"
export * from "./CancelationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports